import React, { useMemo, useState } from "react";
import { FieldInputProps } from "react-final-form";
import AsyncCreatableSelect from "react-select/async-creatable";
import { RequestGetProducts } from "../../../api/product-requests";

type Option = { value: string; label: string };

type FFInput<T> = {
  name: string;
  value: T;
  onChange: (value: T) => void;
  onBlur: (value?: T) => void;
  onFocus: () => void;
};

type FFMeta = {
  touched?: boolean;
  error?: string;
  submitError?: string;
};

type Props = {
  title: string;
  description: string;
  input: FieldInputProps<string | null>;
  meta?: FFMeta;
  options: any[];
  onChange?: (value: string | null) => void;
  setOptions: (opts:any)=>void
  loadOptions: (input: string) => Promise<Option[]>;
  initialOptions?: Option[];
  isClearable?: boolean;
  placeholder?: string;
  className?: string;
};

export default function AsyncCreatableFF({
  title, description,
  input,
  onChange,
  meta,
  loadOptions,
  initialOptions = [],
  isClearable = true,
  placeholder,
  setOptions,
  options,
  className = "react-select-hi-contrast",
}: Props) {

  const [inputText, setInputText] = useState("");

  // find the option object for the FF primitive value


  //   const resolveOptions = async (q: string) => {
  //     const asyncOpts = await loadOptions(q);
  //     // merge with local options (keeps newly-created items visible)
  //     const map = new Map<string, Option>();
  //     [...options, ...asyncOpts].forEach(o => map.set(o.value, o));
  //     const merged = Array.from(map.values());
  //     // keep our state synced so value lookup keeps working
  //     setOptions(merged);
  //     return merged;
  //   };

  const isValidNewOption = (txt: string, _value: Option[], opts: Option[]) => {
    const s = txt.trim().toLowerCase();
    if (!s) return false;
    return !opts.some(
      o => o.label.toLowerCase() === s || o.value.toLowerCase() === s
    );
  };

  const formatCreateLabel = (txt: string) => `Create “${txt}”`;

  const handleCreate = async (label: string) => {
    const trimmed = label.trim();
    // TODO: call your API; assume it returns an id
    // const { id } = await api.createThing({ name: trimmed });
    const id = trimmed.toLowerCase().replace(/\s+/g, "-"); // demo id
    const newOpt = { value: id, label: trimmed, __isNew__: true };
    setOptions((prev:any) => [newOpt, ...prev]);
    input.onChange(newOpt); // Final Form stores the primitive
  };

  const promiseOptionsProduct = (inputValue: string): Promise<any[]> => {
    return new Promise(resolve => {
      if (inputValue.length > 2) {
        RequestGetProducts(undefined, { xPartNumber: inputValue.toUpperCase() }).then(producs => {

          const something = producs.map(ddd => {
            console.log(ddd)

            return { "id": ddd.id, "value": ddd.id, "label": ddd.partNumber, newSalePrice: ddd.newSalePrice, image: ddd.image, weight: ddd.weight, stock: ddd.stock }
          });

          setOptions(something);
          resolve(something)
        })
      } else {
        resolve([])
      }
    });
  }

  const error = meta?.touched && (meta.error || meta.submitError);

  return (<div className="row pb-2 pt-2">
    <div className="col-sm-12 col-md-2">
      <label>{title}</label>
      <p className="descriptionText">{description}</p>
    </div>
    <div className="col-sm-12 col-md-8">
      <AsyncCreatableSelect
        className={className}
        cacheOptions
        defaultOptions
        isClearable={isClearable}

        loadOptions={promiseOptionsProduct}
        options={options}
        value={input.value}
        onChange={(opt) => {
          console.log(opt)
          input.onChange(opt)
        }}
        onCreateOption={handleCreate}
        formatCreateLabel={formatCreateLabel}
        inputValue={inputText}
        onInputChange={(v, meta) => {

          if (meta.action !== "input-blur" && meta.action !== "menu-close") {
            console.log(v, meta)
            setInputText(v);
          }
        }}
        styles={{ menu: base => ({ ...base, zIndex: 9999 }) }}
        onBlur={() => input.onBlur()} // mark touched with current primitive
        getOptionValue={(o:any) => {

          return o.value
        }
        }
        getOptionLabel={(o:any) => {

          return o.label
        }}
      />
    </div>
    <div className="col-sm-12 col-md-2">
      {error && <span className="bg-warning">{error}</span>}
    </div>

  </div>);
}
